import React from 'react'

function PracticeExam3() {
    return (
        <div className='h-screen mt-[-50px] md:mt-0 lg:mt-0 mb-[200px]'>
            <iframe
                src="https://www.aapathshala.com/practice_exam/4269"
                width="100%"
                height="800"
                style={{ border: 'none' }} // ✅ correct: object style
            ></iframe>

        </div>
    )
}

export default PracticeExam3